import { PublicPageTemplate } from "./PublicPageTemplate";

const RecrutementPage = () => (
  <PublicPageTemplate
    badge="Recrutement IA"
    title="Recrutez les meilleurs"
    highlight="talents"
    description="Analyse de CV par IA, matching intelligent et processus de recrutement optimisé pour trouver le candidat idéal."
  />
);
export default RecrutementPage;
